import React, {useState} from 'react'

// material
import {Button, Card, CardContent, Grid, IconButton, InputAdornment,Paper, TextField, withStyles} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
//styles
import styles from './password-card-styles';

const PasswordCardEdit = (props)=> {
  const {
    classes
  } = props;

  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const submitPassword = () => {
    props.setUserPassword(password);
  };
    
  return (
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
            <Grid item>Password</Grid>
        </Grid>

        <Grid container className={classes.displayBody} spacing={2}>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  variant={'outlined'}
                  label={'Password'}
                  value={password}
                  name={'Password'}
                  onChange={e => setPassword(e.target.value)}
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment:
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(true)}
                          onMouseDown={() => setShowPassword(false)}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                  }}/>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  error={confirmPassword.length > 0 && confirmPassword !== password}
                  helperText={confirmPassword.length > 0 && confirmPassword !== password ? 'Does not match password' : ''}
                  fullWidth
                  variant={'outlined'}
                  label={'Confirm Password'}
                  value={confirmPassword}
                  name={'Password'}
                  onChange={e => setConfirmPassword(e.target.value)}
                  type={showConfirmPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment:
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowConfirmPassword(true)}
                          onMouseDown={() => setShowConfirmPassword(false)}
                          edge="end"
                        >
                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                  }}/>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid item className={classes.passwordProgressContainer}>
              <Paper elevation={0} classes={{ root: classes.passwordProgress }}>
                Your password should be:
                <ul>
                  <li className={password.length >= 8 ? classes.passwordConditionMet : ''}>a minimum of 8 characters</li>
                  <li className={password.match(/[A-Z]/) ? classes.passwordConditionMet : ''}>at least 1 upper-case letter</li>
                  <li className={password.match(/[a-z]/) ? classes.passwordConditionMet : ''}>at least 1 lower-case letter</li>
                  <li className={password.match(/[0-9]/) ? classes.passwordConditionMet : ''}>at least 1 number</li>
                </ul>
              </Paper>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Grid container spacing={2}>
              <Grid item>
                <Button 
                  color={'primary'} 
                  size={'small'} 
                  variant={'contained'} 
                  onClick={submitPassword}
                  disabled={password.length < 8 || !password.match(/[A-Z]/) || !password.match(/[a-z]/) || !password.match(/[0-9]/) || confirmPassword !== password}>Save</Button>
              </Grid>
              <Grid item>
                <Button 
                  color={'primary'} 
                  size={'small'} 
                  onClick={() => props.toggleEdit()}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

      </CardContent>
    </Card>
  )
};

export default withStyles(styles) (PasswordCardEdit);